module.exports = __webpack_public_path__ + "img/icon-wbig.243c58c3.png";